import { render, staticRenderFns } from "./sin-canvas.vue?vue&type=template&id=87c04a3c&scoped=true"
import script from "./sin-canvas.vue?vue&type=script&lang=js"
export * from "./sin-canvas.vue?vue&type=script&lang=js"
import style0 from "./sin-canvas.vue?vue&type=style&index=0&id=87c04a3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c04a3c",
  null
  
)

export default component.exports